'use strict';

Odigeo.defineWidget('accommodation_selector', Odigeo.Widget.extend({
    modelClass: require('../modules/models/accommodation_selector'),

    viewClass: require('../modules/views/accommodation_selector'),

    init: function() {
        this.options = Odigeo.parseOptions(this.options);
    },

    updateData: function(data) {
        this.view.toggle(true);
        this.model.set('locations', data);
        this.view.renderTemplate();
    },

    onResetFilter: function() {
        this.model.clearFilter();
    },

    getInputValue: function() {
        var value = this.view.$cachedSelectors.input.val();
        Odigeo.trigger(this.id + ':returnInputValue', value);
    },

    triggerUpdateEvents: function() {
        var value = this.model.getValue();
        if (Odigeo._.isEmpty(value)) {
            this.trigger('invalid');
        } else {
            this.trigger('change', value);
        }
    },

    setValue: function() {
        this.model.setValue.apply(this.model, arguments);
    },

    toggle: function(enable) {
        this.view.toggle(enable);
    },

    focus: function(dontFocusInput) {
        // This fixes a really nasty bug in IE
        if (!dontFocusInput) {
            this.view.$cachedSelectors.input.focus();
        }
        this.trigger(Odigeo.Events.focus);
    },

    blur: function() {
        this.view.hideAll();
        this.trigger(Odigeo.Events.blur);
    },

}));
